<template>
  <Select label="Fecha" :options="fechasFormateadas" :modelValue="fechaSelected" @change="selectFecha" />
</template>
<script setup>
  import { computed } from "vue"
  import { formatFechaDesk } from "@/helpers"
  import Select from "@/components/Select"

  const props = defineProps({
    fechas: {
      type: Array,
      required: true,
    },
    fechaSelected: {
      type: String,
    },
  })

  const fechasFormateadas = computed(() => {
    const ff = props.fechas.map((f, index) => {
      return {
        id: index,
        label: formatFechaDesk(f),
        value: f,
      }
    })
    return ff
  })

  const emit = defineEmits({ select: "String" })

  const selectFecha = () => {
    emit("select")
  }
</script>
